import { textAndImageBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  eyebrow: 'test',
  header: 'Our Shops & Advisors Overview',
  bodyText:
    'Nullam ac diam id arcu venenatis vulputate. Cras ligula massa, imperdiet at eros eget, mollis molestie diam. Quisque elementum ut urna vulputate maximus. Mauris tincidunt convallis placerat. Maecenas commodo, leo id bibendum porttitor, odio neque congue purus, nec porttitor odio nulla nec nisl. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dapibus nunc ante, sed efficitur mi facilisis et. Morbi tempus congue lectus ac luctus. Etiam erat lectus, tincidunt in orci sit amet, porta sollicitudin magna. Aenean eros mauris, lacinia sit amet urna sed, mollis hendrerit lacus. Proin rutrum, arcu eleifend gravida condimentum, ligula tortor condimentum ex, eu bibendum felis felis id orci. Donec mollis tellus orci, pellentesque varius turpis congue vel. Proin at justo lacus. Morbi ac purus vitae purus a, varius ante. Curabitur eleifend tellus a metus maximus semper. Vestibulum tincidunt arcu est, nec sagittis nunc laoreet eu.',
  img: '/assets/textimageplaceholder.png',
  cta: [
    { url: '#', text: 'Learn More' },
    { url: '#', text: 'Learn More' },
  ],
  btnText: 'Learn More',
  btnUrl: '#',
  reverse: true,
};

export default fakeProps(schema, TestData);
